export const cilMenu = ["24 24","<path d='M3.75 4.5h16.5v1.5h-16.5v-1.5z'></path><path d='M3.75 11.25h16.5v1.5h-16.5v-1.5z'></path><path d='M3.75 18h16.5v1.5h-16.5v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-menu.js
// module id = null
// module chunks = 